<template>
  <div class='themeMenu'>
    <div class='button' v-on:click='switchTheme'>
      <i class='fa' :class='icon'></i>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    icon: {
      type: String,
      default: ''
    },
    hourToForce: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {}
  },
  methods: {
    switchTheme() {
      this.data.forcedHour = this.hourToForce
    }
  }
}
</script>
<style lang='scss' scoped>

.themeMenu {
  position: fixed;
  top: 5px;
  right: 65px;
  cursor: pointer;

  .button {
    width: 60px;
    height: 60px;
    position: absolute;
    transform: scale(0.55);
    box-shadow: none;
    background: #382872;
    color: #eb76ae;
    font-size: 40px;
    text-align: center;
    border-radius: 50%;
  }
}

</style>
